/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-02-10 10:04:03
 * @LastEditors: sj
 * @LastEditTime: 2022-02-10 17:42:06
 */
import { ADMIN_API_PREFIX } from './constant'
import { Request } from './request'

export interface ReplaceMakeOrderListBody {
  pageSize?: number
  pageNum?: number
  param?: string
  supplierKeyWord?: string
  tenantkeyWord?: string
  createListTimeHead?: string
  createListTimeTail?: string
  status?: number
}
//  代煎订单列表
export const ReplaceMakeOrderList = (
    body:ReplaceMakeOrderListBody
): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/potionRecipe/page`,
    method: 'POST',
    body,
  }
}
// 订单金额合计
export const ReplaceMakeOrderAmount = (
    body:ReplaceMakeOrderListBody
) : Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/potionRecipe/getPrescriptionAmount`,
    method: 'POST',
    body,
  }
}

// 代煎订单详情
export interface ReplaceMakeOrderDetailParams {
  size?: number
  current?: number
  id?: string
}
export const ReplaceMakeOrderDetail = (
  params: ReplaceMakeOrderDetailParams
): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionrecipe/detail`,
    method: 'GET',
    params,
  }
}

// 数据统计
export interface ReplaceMakeOrderStatisticAnalysisParams {
  flag: number
  status: number
  supplierId: string | number // 供应商名称
  platformId: string | number // 机构名称
}
export const ReplaceMakeOrderStatisticAnalysis = (
  params: ReplaceMakeOrderStatisticAnalysisParams
): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionstatistics/potionstatisticslist`,
    method: 'GET',
    params,
  }
}
